import React from 'react';
import NpCard from '../NpCard';
import { LangContext } from '../../contexts/LangContext';
import './StoreItems.css';

// ─── Componente principal ──────────────────────────────────────────────────
export default function StoreItems({ items = [], onAddToCart, cart = {}, onQtyChange, onRemove }) {
  const { t } = React.useContext(LangContext);
  const cheap     = items.filter((i) => i.size === 'small');
  const expensive = items.filter((i) => i.size === 'large');

  return (
    <div className="store-items-wrapper">
      <div className="main-grid">
        {/* Cols 1-2: 4 itens baratos em sub-grid 2x2 */}
        <div className="cheap-sub-grid">
          {cheap.map((item) => (
            <NpCard key={item.sku} item={item} expensive={false} onAddToCart={onAddToCart} cartQty={cart[item.sku]?.qty || 0} onQtyChange={onQtyChange} onRemove={onRemove} />
          ))}
        </div>

        {/* Cols 3-5: itens caros */}
        {expensive.map((item) => (
          <NpCard key={item.sku} item={item} expensive={true} onAddToCart={onAddToCart} cartQty={cart[item.sku]?.qty || 0} onQtyChange={onQtyChange} onRemove={onRemove} />
        ))}
      </div>
    </div>
  );
}
